var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header-wide",attrs:{"hide-when-narrow":""}},[_c('div',{staticClass:"title-wrapper"},[_c('img',{attrs:{"src":"https://s3plus.meituan.net/www-assets/shared/images/logo/main-logo-2023.svg","alt":"logo"}}),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }